import { allHelpCenterPosts, allKnowledgeBasePosts } from "content-collections";
import type { DocsCenterNavSection } from "@/components/docs/docs-center-layout";

type KnowledgeBasePost = (typeof allKnowledgeBasePosts)[number];

export function getKnowledgeBaseDisplayTitle(
	post: Pick<KnowledgeBasePost, "title" | "navTitle">,
): string {
	return post.navTitle ?? post.title;
}

export function getHelpCenterNavSections(): DocsCenterNavSection[] {
	const posts = allHelpCenterPosts
		.filter((post) => post.published !== false)
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

	return [
		{
			name: "Help center",
			items: posts.map((post) => ({
				slug: post._meta.path,
				title: post.title,
				summary: post.summary,
			})),
		},
	];
}

export function getKnowledgeBaseNavSections(): DocsCenterNavSection[] {
	const posts = allKnowledgeBasePosts
		.filter((post) => post.published !== false)
		.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

	const grouped = new Map<string, typeof posts>();
	for (const post of posts) {
		const category = post.category ?? "Reference";
		const list = grouped.get(category) ?? [];
		list.push(post);
		grouped.set(category, list);
	}

	return [...grouped.entries()].map(([name, items]) => ({
		name,
		items: items.map((post) => ({
			slug: post._meta.path,
			title: getKnowledgeBaseDisplayTitle(post),
			summary: post.summary,
		})),
	}));
}

export function getHelpCenterPost(slug: string) {
	return allHelpCenterPosts.find(
		(post) => post._meta.path === slug && post.published !== false,
	);
}

export function getKnowledgeBasePost(slug: string) {
	return allKnowledgeBasePosts.find(
		(post) => post._meta.path === slug && post.published !== false,
	);
}
